/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-01 22:30:09
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import { Integer, IViewDate } from 'src/types/base';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumStationType from 'src/enums/enumStationType';
import alertSelectLocationModal from './component/selectLocationModal';
import AreaCascader from 'src/components/areaCascader/areaCascader';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import InputNumber from 'src/types/iview/InputNumber';
import EnumWaterLever from 'src/enums/enumWaterLever';
import EnumPowerType from 'src/enums/enumPowerType';
import EnumDataCompare from 'src/enums/enumDataCompare';
import EnumDataStatus from 'src/enums/enumDataStatus';
import { createNamespace } from 'src/util/bem';
import { CommonUtil } from 'src/util/commonUtil';
import StationConfigApi, { StationConfigDOI } from './api/stationConfigApi';
import EnumOperates from 'src/enums/enumOperates';
import EnumControlLevel from 'src/enums/enumControlLevel';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import  DatePicker from 'src/types/iview/DatePicker';

export namespace StationOperateVOI {
    export interface PropsI {
        operate: string;
        id?: number;
        saveSuccess?(): void;
        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        name: string;
        type: Integer;
        mn: string;
        section: string;
        location_point: string;
        area: number[];
        address: string;
        agreement_id: Integer;
        meter_time: Integer;
        product_id: Integer;
        water_level: Integer;
        power_type: Integer;
        basin_id: Integer;
        msisdn: string;
        fakedata_status: Integer;
        devops_personnel: string;
        devops_mobile: string;
        remark: string;
        control_hierarchy: Integer;
        factorset: Integer;
        is_sort: Integer;
        operational_cycle: Integer;
        component_id: Integer;
        decimal_place:Integer;
        alarm_value: Integer;
        alarm_mn:string;
        built_time:IViewDate;
        reception_time:IViewDate;
    }
}

@Component
class StationOperateModal extends Vue.Component<StationOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: StationOperateVOI.FormDataI = {
        name: '',
        type: null,
        mn: '',
        section: '',
        location_point: '',
        area: [],
        address: '',
        agreement_id: null,
        meter_time: null,
        product_id: null,
        water_level: null,
        power_type: null,
        basin_id: null,
        msisdn: '',
        fakedata_status: null,
        devops_personnel: '',
        devops_mobile: '',
        remark: ' ',
        control_hierarchy: null,
        factorset: 0,
        is_sort: null,
        operational_cycle: null,
        component_id: -2,
        decimal_place:1,
        alarm_value:null,
        alarm_mn:'',
        built_time:null,
        reception_time:null,
        
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async getDecimalPlace(){
        let { code, data } = await StationConfigApi.queryComponentDecimalPlace({"mn": this.formData.mn,"factorset": this.formData.factorset, "component_id":this.formData.component_id});
        if(code === 0){
            if(data == null){
                this.formData.decimal_place = 1
            }
            else{
                this.formData.decimal_place = data['decimal_place_value']
            }
        }
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        this.formData.built_time = DateTimeUtil.getSecondFromIviewDate(this.formData.built_time)
        this.formData.reception_time = DateTimeUtil.getSecondFromIviewDate(this.formData.reception_time)
        let params: StationConfigDOI.OperateParamsI = {
            ...this.formData,
            province_id: this.formData.area[0],
            city_id: this.formData.area[1],
            district_id: this.formData.area[2],
            power_type: this.formData.power_type||-2
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await StationConfigApi.add(params);
                break;
            case EnumOperates.Update.getName():
                debugger
                params.device_id = this.id;
                res = await StationConfigApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async selectLocation() {
        let area = (this.$refs.area as any).getCurrentArea()
        let res = await alertSelectLocationModal({
            location_point: this.formData.location_point,
            areaNames: area.map(i=> i.name),
            address: this.formData.address
        });
        this.formData.location_point = res!.location;
        this.formData.address = res!.address;
        (this.$refs.area as any).setAreaByName(res!.areaNames)
    }
    async mounted() {
        if (this.operate === EnumOperates.Update.getName()) {
            let { code, data } = await StationConfigApi.searchDetail(this.id);
            if (code === 0) {
                if(!data[0].hasOwnProperty("alarm_value"))
                {
                    data[0]["alarm_value"] = null;
                }
                if(!data[0].hasOwnProperty("component_id")){
                    data[0]["component_id"] = -2;
                }
                this.formData = {
                    ...data[0],
                    basin_id: +data[0].basin,
                    area: [data[0].province_id, data[0].city_id, data[0].district_id],
                    decimal_place: 1,
                };
                setTimeout(()=> {
                    (this.$refs.area as any).matchData()
                })
                this.formData.built_time = DateTimeUtil.GMTToStr(this.formData.built_time)
                this.formData.reception_time = DateTimeUtil.GMTToStr(this.formData.reception_time)
            }
        }
    }
    created() {
        let t = this;
        this.rules = {
            area: [
                {
                    validator(rule, value, callback) {
                        if (t.formData.area.some(i => CommonUtil.isFieldEmpty(i)) || !t.formData.address) {
                            callback(new Error('请填选地址'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }

    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={this.operate + '站点'}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="站点名称" prop="name" style="display: inline-block;width:45%" required>
                        <Input v-model={this.formData.name} placeholder="请输入" />
                    </form-item>
                    <form-item label="mn号" prop="mn" style="display: inline-block;width:45%" required>
                        <Input v-model={this.formData.mn} placeholder="请输入" />
                    </form-item>
                    <form-item label="站点类型" prop="type" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumStationType.getList() as any} v-model={this.formData.type} placeholder="请输入" />
                    </form-item>
                    <form-item label="检测位置" prop="section" style="display: inline-block;width:45%" required>
                        <Input v-model={this.formData.section} placeholder="请输入" />
                    </form-item>
                    <form-item label="控制级别" prop="control_hierarchy" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumControlLevel.getList()} v-model={this.formData.control_hierarchy} />
                    </form-item>
                    <form-item label="经纬度" prop="location_point" style="display: inline-block;width:45%" required>
                        <div on-click={this.selectLocation.bind(this)}>
                            <Input v-model={this.formData.location_point} placeholder="请输入" readonly />
                        </div>
                    </form-item>
                    <form-item label="站点地址" prop="area" style="display: inline-block;width:90%" class="ivu-form-item-required">
                        <div style="display: inline-block;width:50%">
                            <AreaCascader ref="area" v-model={this.formData.area} />
                        </div>
                        <Input v-model={this.formData.address} placeholder="请输入" style="display: inline-block;width:50%" />
                    </form-item>
                    <form-item label="通讯协议" prop="agreement_id" style="display: inline-block;width:45%" required type="number">
                        <EntitySelect type={EnumEntity.Agreement.getId()} v-model={this.formData.agreement_id} />
                    </form-item>
                    <form-item label="通讯判断时间" prop="meter_time" style="display: inline-block;width:45%" required type="number">
                        <InputNumber
                            class="wqms-input-number"
                            min={0}
                            precision={1}
                            v-model={this.formData.meter_time}
                            placeholder="请输入"
                        />
                    </form-item>
                    <form-item label="测量类型" prop="product_id" style="display: inline-block;width:45%" required type="number">
                        <EntitySelect type={EnumEntity.Measuring.getId()} v-model={this.formData.product_id} />
                    </form-item>
                    <form-item label="测量因子组" prop="factorset" style="display: inline-block;width:45%" required type="number">
                        <EntitySelect type={EnumEntity.ComponentProduct.getId()} v-model={this.formData.factorset} on-change={() => {
                            this.formData.component_id = -2;
                            if(this.formData.factorset == null){
                                this.formData.factorset = 0
                            }
                        }}/>
                    </form-item>
                    <form-item label="目标等级" prop="water_level" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumWaterLever.getList()} v-model={this.formData.water_level} />
                    </form-item>
                    <form-item label="供电类型" prop="power_type" style="display: inline-block;width:45%"  type="number">
                        <CommonSelect dataSource={EnumPowerType.getList()} v-model={this.formData.power_type} />
                    </form-item>
                    <form-item label="流域" prop="basin_id" style="display: inline-block;width:45%" required type="number">
                        <EntitySelect type={EnumEntity.Basin.getId()} v-model={this.formData.basin_id} />
                    </form-item>
                    <form-item label="SIM卡" prop="msisdn" style="display: inline-block;width:45%" >
                        <Input v-model={this.formData.msisdn} placeholder="请输入" />
                    </form-item>
                    <form-item label="数据对比" prop="is_sort" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumDataCompare.getList()} v-model={this.formData.is_sort} />
                    </form-item>
                    {/* <form-item label="虚拟数据状态" prop="fakedata_status" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumDataStatus.getList()} v-model={this.formData.fakedata_status} />
                    </form-item> */}
                    <form-item label="运维人员" prop="devops_personnel" style="display: inline-block;width:45%">
                        <Input placeholder="请输入" v-model={this.formData.devops_personnel} />
                    </form-item>
                    <form-item label="联系方式" prop="devops_mobile" style="display: inline-block;width:45%">
                        <Input placeholder="请输入" v-model={this.formData.devops_mobile} />
                    </form-item>
                    <form-item label="运维周期(天)" prop="operational_cycle" style="display: inline-block;width:45%" required type="number">
                        <InputNumber
                            class="wqms-input-number"
                            min={1}
                            precision={0}
                            v-model={this.formData.operational_cycle}
                            placeholder="请输入"
                        />
                    </form-item>
                    
                    <form-item label="因子" prop="component_id" style="display: inline-block;width:45%"  type="number">
                        <EntitySelect
                            type={EnumEntity.ComponentDetails.getId()}
                            searchParams={{ "factorset": this.formData.factorset }}
                            v-model={this.formData.component_id}
                            on-change={() => {
                                if(this.formData.component_id != null){
                                    this.getDecimalPlace()
                                }
                            }}
                        />
                    </form-item>
                    <form-item label="小数位数" prop="decimal_place" style="display: inline-block;width:45%"  type="number">
                        <InputNumber
                            class="wqms-input-number"
                            min={1}
                            max={8}
                            precision={0}
                            v-model={this.formData.decimal_place}
                            placeholder="请输入"
                        />
                    </form-item>
                    <form-item label="报警阈值" prop="alarm_value" style="display: inline-block;width:45%" required type="number">
                        <InputNumber
                            class="wqms-input-number"
                            v-model={this.formData.alarm_value}
                            placeholder="请输入"
                        />
                    </form-item>
                    <form-item label="报警器mn" prop="alarm_mn" style="display: inline-block;width:45%" >
                        <Input v-model={this.formData.alarm_mn} placeholder="请输入" />
                    </form-item>
                    <form-item label="建立时间" prop="built_time" type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.built_time} />
                    </form-item>
                    <form-item label="验收时间" prop="reception_time" type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.reception_time} />
                    </form-item>
                    <form-item label="备注" prop="remark" style="display: inline-block;width:90%">
                        <Input placeholder="请输入" v-model={this.formData.remark} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertStationOperateModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<StationOperateVOI.PropsI>(StationOperateModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
